class ReactFilterHousehold extends React.Component {

    constructor(props) {
        super(props);
    }
    
    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {
        return {
            household_id:this.refs.combo.getValues()
        };
    }
    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.refs.combo.clearValues()
    }

    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        if(values.household_id){
            this.refs.combo.setValues({
                value:values.household_id
            })
        }else{
            this.clearValues();
        }
    }

    render() {
        var householdId = '';

        if(this.props.settings.household_id){
            householdId = this.props.settings.household_id
        }else if(parseInt(this.props.settings.logged_in_person)){
            householdId = SS.vars.Person.household_id;
        }
        
        var params = {
            ref:'combo',
            label: this.props.label,
            url: SS.route('People','Households','getAll',null,'json'),
            value:householdId,
            paginated:true,
            idField:'id',
            minChars:this.props.settings.min_chars,
            urlParams:{
                limit:10,
                simple:true
            },
            applyFilters: this.props.applyFilters,
            clearFilters: this.props.clearFilters,
            loadGrid: this.props.loadGrid
        };

        return React.createElement(ReactFilterCombo,params);
    }
};